/* eslint-disable import/first */
import React from 'react';
import { Button } from '@material-ui/core';
import ClassNames from 'classnames';
import deleteIcon from './images/delete.svg';

import { FormattedMessage } from 'react-intl';

import css from './index.module.scss';
const Addtocart = ({ qty, onIncrement, onDecrement }) => {
  return (
    <>
      {qty === 0 ? (
        <div className={css.addToCart}>
          <Button variant="contained" color="primary" size="medium" fullWidth onClick={onIncrement}>
            <FormattedMessage id="product_addtocart" defaultMessage="+ Add to cart" />
          </Button>
        </div>
      ) : (
        <div className={ClassNames(css.addToCart, css.added)}>
          <Button
            variant="outlined"
            color="success"
            className={css.deleteButton}
            onClick={onDecrement}
          >
            {qty === 1 ? <img src={deleteIcon} alt="" /> : '-'}
          </Button>
          <span>{qty > 9 ? qty : `0${qty}`}</span>
          <Button variant="contained" color="primary" onClick={onIncrement}>
            +
          </Button>
        </div>
      )}
    </>
  );
};

export default Addtocart;
